import { apiClient, ApiClient } from "@/lib/api/api-client";
import { Province, Ward } from "@/modules/types/metadata/metadata";
import { BaseResponse } from "@/modules/types/response";

export interface ProvinceResponse extends BaseResponse {
  provinces: Province[];
}

export interface WardResponse extends BaseResponse {
  wards: Ward[];
}

export class LocationService {
  private BASE_PATH =
    process.env.API_MAPDATA_ENDPOINT || "http://localhost:8003/map";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getProvinces(keyword?: string): Promise<ProvinceResponse> {
    const query = keyword ? `?keyword=${encodeURIComponent(keyword)}` : "";
    return await this.apiClient.fetch<ProvinceResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/provinces${query}`,
      {
        cache: "force-cache",
      },
    );
  }

  async getWards(
    provinceCode: string,
    keyword?: string,
  ): Promise<WardResponse> {
    const keywordQuery = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
    return await this.apiClient.fetch<WardResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/wards?provinceCode=${encodeURIComponent(provinceCode)}${keywordQuery}`,
      {
        cache: "force-cache",
      },
    );
  }
}

export const locationService = new LocationService();
